// extracted by mini-css-extract-plugin
export default {"formHeading":"qK-z","form":"rK-z","submitBtn":"sK-z","disabled":"tK-z","input":"uK-z","error":"vK-z","submitMsg":"wK-z","signIn":"xK-z"};